import Password from "@hudson/ui/components/FormFields/Password";
import useContent from "@lib/use_content";

export default function NewPassword({ ...props }) {
  const { data, loading } = useContent(["beErrPasswordMinLength"]);

  return (
    !loading && (
      <Password
        fieldValidations={{
          validate: {
            minLength: (v) => v.length >= 8 || data?.content.beErrPasswordMinLength,
          },
        }}
        {...props}
      />
    )
  );
}
